<template>
  <a-card style="height: 100%">
    <iframe
      ref="myIframe"
      src="https://eminwechat.xjzdcsyyyxzrgs.com/proxy-lab/?viewName=emin_view"
      scrolling="auto"
      frameborder="0"
      style="width: 100%; height: 100vh"
    ></iframe>
  </a-card>
</template>
  
  <script>
export default {
  name: 'HJplcList',
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>
  
  <style scoped>
@import '~@assets/less/common.less';
</style>